/**
 * @file: TaskProductManifestItemOrigin.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum TaskProductManifestItemOrigin {
  TaskDetail = 'task_detail',
  Inspection = 'inspection',
  InspectionPreview = 'inspection_preview',
  Construction = 'construction',
  ConstructionPreview = 'construction_preview',
}

export const TaskProductManifestItemOriginValueSet = new Set([
  TaskProductManifestItemOrigin.TaskDetail,
  TaskProductManifestItemOrigin.Inspection,
  TaskProductManifestItemOrigin.InspectionPreview,
  TaskProductManifestItemOrigin.Construction,
  TaskProductManifestItemOrigin.ConstructionPreview,
]);
